import React, { useCallback, useEffect } from 'react';
// Types
import { ProductionEventProps, OrderLinesProps } from 'types/productionEvent';
// Utils
import { delay, useSetState, validArray } from 'utils';
import { checkActiveResendEvent, setResendEvent, sortByDate } from 'utils/events'
// App Actions
import { addNotification } from 'context/AppContext/actions';
// App Context
import { useAppDispatch } from 'context/AppContext';
// Auth Context
import { useAuthState } from 'context/AuthContext';
// Event Context
import { resendEvents } from 'context/EventContext/middleware';
import { useEventDispatch, useEventState } from 'context/EventContext';
import * as eventFlags from 'context/EventContext/statusFlags';
// Assets
import Icon from 'assets/Icon';
// Elements
import Alert from 'elements/Alert';
import Button from 'elements/Button';
// Global Components
import PageHeader from 'components/PageHeader';
// Components
import Event from './components/Event';
import EventFilterBar from './components/EventFilterBar';
// Styles
import styles from './style/eventLog.module.css';

function EventLog() {
  // Auth State
  const { defaultOrganisation: { orgRef } } = useAuthState();
  // App State
  const appDispatch = useAppDispatch();
  // Event State
  const { eventFilters } = useEventState()
  const eventDispatch = useEventDispatch();
  const { events, eventState } = useEventState();
  // State
  const initialState = {
    loading: true,
    resendEvents: {},
  }
  const [state, setState] = useSetState(initialState);
  

  const loadingData = (
    eventState === eventFlags.GET_EVENTS
      || eventState === eventFlags.RESOLVE_EVENTS
      || eventState === eventFlags.RESEND_EVENTS
  );
  const eventPatchSuccess = (
    eventState === eventFlags.RESEND_EVENTS_SUCCESS
      || eventState === eventFlags.RESOLVE_EVENTS_SUCCESS
  );

  const initiatePage = useCallback(async () => {
    await delay(200);
    setState({ loading: false });
    if (eventState === eventFlags.GET_EVENTS_SUCCESS) {
      // setState({ loading: false });
    }
  }, [setState, eventState]);

  function renderEvents(event:ProductionEventProps) {
    return (
      <Event
        actionActive={checkActiveResendEvent(state.resendEvents, event)}
        event={event}
        key={event.orderInfo.id}
        activeEvent={state.resendEvents}
        toggleAction={(childEvent: OrderLinesProps) => {
          if (event.orderInfo.targetERP === 'TROPOS') {
            appDispatch(addNotification({
              label: 'Order will be processed in line with the next Tropos run.',
              type: 'info',
            }))
          } else if (state.resendEvents.orderInfo && !checkActiveResendEvent(state.resendEvents, event)) {
            appDispatch(addNotification({
              label: 'Multiple events cannot be submitted together. Please submit or clear previous selection.',
              type: 'error',
            }))
          } else {
            setState({
              resendEvents: setResendEvent(state.resendEvents, event, childEvent),
            })
          }
        }}
      />
    )
  }

  useEffect(() => {
    if (eventPatchSuccess) {
      setState({ resendEvents: {} });
    }
  }, [eventPatchSuccess, eventState, setState]);

  useEffect(() => {
    setState({ resendEvents: {} })
  }, [eventFilters, setState]);

  useEffect(() => {
    initiatePage();
  }, [initiatePage]);

  return (
    <>
      <PageHeader heading="Event Log" />
      <section className="wrapper">
        <div className={`wrapper__content ${styles.container}`}>
          { state.loading || (loadingData && eventFilters.offSet === 0) ? (
            <div className={`${styles.loading} ${styles.grid}`}>
              {[...Array(8)].map((e, i) => <span key={i.toString()} />)}
            </div>
          ) : (
            <>
              {events && events.length > 0 ? (
                <div className={styles.grid}>
                  {validArray(events) && events.sort(sortByDate).map(renderEvents)}
                </div>
              ) : (
                <Alert active={true} type="info" label="No Events Found" />
              )}
            </>
          )}
        </div> 
      </section>
      <EventFilterBar />
      <div className={`${styles.resendEvents} ${JSON.stringify(state.resendEvents) !== '{}'  ? styles.resendEvents_active : ''}`}>
        <button type="button" onClick={() => setState({ resendEvents: {} })}>
          <Icon icon="Close" fill="white" />
        </button>
        <Button
          btnStyle="tertiary"
          handler={() => resendEvents({
            appDispatch,
            eventDispatch,
            eventFilters,
            event: state.resendEvents,
            orgRef,
          })}
        >
          Resend { `${state.resendEvents.orderLines && state.resendEvents.orderLines.length > 1 ? state.resendEvents.orderLines.length : 1 }` } Event{ state.resendEvents.orderLines && state.resendEvents.orderLines.length > 1 && ('s') }
        </Button>
      </div>
    </>
  );
}

export default EventLog;
